import { render } from "./AddInp.vue?vue&type=template&id=54715070&scoped=true"
import script from "./AddInp.vue?vue&type=script&lang=js"
export * from "./AddInp.vue?vue&type=script&lang=js"

import "./AddInp.vue?vue&type=style&index=0&id=54715070&scoped=true&lang=css"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54715070"]])

export default __exports__